enum UserType {
  Client = "client",
  Chef = "chef",
}

export default UserType;
